import { InfoWithLabel } from "@volca/ui/components/ui/info-with-label";
import { Stack } from "@volca/ui/components/ui/stack";
import {
  DocumentTimestamps,
  MatchedJobField,
  PurchaseOrderField,
  QuickbooksBillField,
} from "@/accounts-payable/common";
import type { ApInvoice } from "@/accounts-payable/types";
import { formatApDate } from "@/accounts-payable/utils";

export const InvoiceFieldsSection = ({
  invoice,
  businessId,
}: {
  invoice: ApInvoice;
  businessId: string | null;
}) => (
  <Stack gap={6}>
    <Stack gap={4}>
      <MatchedJobField document={invoice} businessId={businessId} />
      <PurchaseOrderField document={invoice} businessId={businessId} />
      <QuickbooksBillField invoice={invoice} businessId={businessId} />
    </Stack>
    <Stack gap={0} className="grid w-full grid-cols-2 gap-4">
      <InfoWithLabel label="Due date">
        {formatApDate(invoice.due_date)}
      </InfoWithLabel>
      <InfoWithLabel label="Vendor PO field">
        {invoice.po_number ?? "—"}
      </InfoWithLabel>
      <InfoWithLabel label="Service address" className="col-span-2">
        {invoice.service_address ?? "—"}
      </InfoWithLabel>
    </Stack>
    <DocumentTimestamps document={invoice} />
  </Stack>
);
